import {post,get} from '@/libs/ajax.js'
/**
 * 获取配置表格
 * @param {*} data 
 * @returns 
 */
export async function getConfigTablesInfoApi(data) {
    
    return get('/config_manage/get_tables_info', data)
}
/**
 * 根据name获取表字段
 * @param {*} data 
 * @returns 
 */
export function getConfigTableFieldsApi(data) {
    
    return get('/config_manage/get_table_fields', data)
}
/**
 * 获取配置表数据
 * @param {*} data 
 * @returns 
 */
export function getConfigListApi(data) {
  return get('/config_manage/get_list', data)
}
/**
 * 获取下拉框配置
 * @param {*} data 
 * @returns 
 */
export function getConfigOptionsListApi(data) {
  return get('/config_manage/get_options_list', data)
}
/**
 * 编辑配置信息
 * @param {*} data 
 * @returns 
 */
export function editConfigListItemApi(data) {
  return post('/config_manage/edit', data)
}
/**
 * 添加配置数据
 * @param {*} data 
 * @returns 
 */
export function addConfigListItemApi(data) {
  return post('/config_manage/add', data)
}